const UserSessionReducer = (state, action) => {
    switch (action.type) {
        case 'SET_USER':
            return {
                ...state,
                user: action.payload,
            };
        case 'REMOVE_USER':
            return {
                ...state,
                user: null,
            };
        case 'SET_ACCESS_TOKEN':
            return {
                ...state,
                access_token: action.payload,
            };
        case 'REMOVE_ACCESS_TOKEN':
            return {
                ...state,
                access_token: null,
            };
        case 'SET_PLAYER':
            return {
                ...state,
                player: action.payload,
                prepaid_player_id: action.payload.prepaid_player_id || null,
            };
        case 'REMOVE_PLAYER':
            return {
                ...state,
                player: null,
            };
        case 'SET_WALLET':
            return {
                ...state,
                wallet: action.payload,
                prepaid_wallet_id: action.payload.prepaid_wallet_id || null,
            };
        case 'REMOVE_WALLET':
            return {
                ...state,
                wallet: null,
            };
        case 'SET_BALANCE':
            return {
                ...state,
                balance: action.payload,
            };
        case 'REMOVE_BALANCE':
            return {
                ...state,
                balance: null,
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};

export default UserSessionReducer;